const adminEmails = [
  "swcfischer@gmail.com",
  "zswcfischer@gmail.com",
  "stevefischerswe@gmail.com",
  "steve@avidlanguagelearning.com",
];

export default adminEmails;
